module.exports = __webpack_public_path__ + "img/MSC.b2be5eed.svg";